import JelWorkspace from '@/store/classes/jelWorkspace';

const jelWorkspace = new JelWorkspace({
  module: 'dossier',
  refreshMinProd: process.env.VUE_APP_STORE_DOSSIER_REFRESH_MIN,
  refreshMinDev: process.env.VUE_APP_STORE_DEV_REFRESH_MIN,
});

const state = {
  ...jelWorkspace.state,
  versionDonnees: null,
  clientMigrated: null,
  custUUID: null,
  lastUpdate: '',
};
const getters = {
  ...jelWorkspace.getters,

  getLastUpdate: (state) => {
    return state.lastUpdate;
  },
};
const actions = {
  ...jelWorkspace.actions,

  reset({ commit }) {
    commit('RESET');
  },
  setLastUpdate: ({ commit, state }, value) => {
    commit('SET_LASTUPDATE', value);
    return state.lastUpdate;
  },
};
const mutations = {
  ...jelWorkspace.mutations,

  async INIT(state) {
    if (!state.isLoaded) {
      this.commit(`${state.module}/INTERNAL_INIT`);
    }
  },

  RESET(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    state.versionDonnees = null;
    state.clientMigrated = null;
    state.custUUID = null;
    state.lastUpdate = '';
  },
  // Dossier
  SET_DOSSIER_CUSTUUID(state, value) {
    state.custUUID = value;
  },
  SET_DOSSIER_VERSION_DONNEES(state, value) {
    state.versionDonnees = value;
  },
  SET_DOSSIER_CLIENT_MIGRATED(state, value) {
    state.clientMigrated = value;
  },
  SET_LASTUPDATE: (state, value) => {
    state.lastUpdate = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
